export const FETCH_MY_PERMISSIONS = 'permissions@fetch-my-permissions';
export const FETCH_MY_PERMISSIONS_SUCCESS = 'permissions@fetch-my-permissions-success';
export const FETCH_MY_PERMISSIONS_FAILURE = 'permissions@fetch-my-permissions-failure';
export const CLEAR_PERMISSIONS = 'permissions@clear-permissions';
